import React, { createContext, useContext } from "react";

// 1. Create the context with a default value of null
const ReportContext = createContext(null);

// 2. Create a custom hook for easy consumption
export function useReportContext() {
  return useContext(ReportContext);
}

// 3. Create the provider component that will wrap the report routes
export function ReportProvider({ children }) {
  // This provider simply signals its presence by providing a non-null value.
  const value = { isReportContext: true };
  return (
    <ReportContext.Provider value={value}>{children}</ReportContext.Provider>
  );
}
